
import { ref } from '@vue/composition-api'
import store from '@/store'
import { plans, devices, owners, contracts, reFilterDevices, reFilterPlans ,containers} from '@/app/reports/share/helper'
import { ReportService } from '@/app/reports/share/report.service'
export default function reportForm() {

  const camps = ref([])
  const tanks = ref([])
  const fills = ref([])
  const irrigations = ref([])

  ReportService.getDevicesOptions({
    type: 'device',
    user: store.state.auth.userData.id
  }).then(response => devices.value = response.data.map((d)=>({id:d.device_id,"name":d.name})))


  ReportService.getDevicesOptions({
    type: 'user',
    user: store.state.auth.userData.id,
    isOwner:true
  }).then(response => { owners.value = response.data })



  ReportService.getDevicesOptions({
    type: 'contract',
    user: store.state.auth.userData.id
  }).then(response => {
    // console.log("contracrs",response.data), W

    contracts.value = response.data
  })


  // GardenReportService.getAreasOptions({
  //   type: 'geofence',
  //   user: store.state.auth.userData.id,
  //   cols: 'id,name,category'
  // }).then(response => {

  //   response.data.map(area => {
  //     let ref = area.category.toLowerCase()
  //     eval(`${ref}`).value.push(area)
  //   })

  // })



  ReportService.getPlanOptions({
    type: "plan",
    planType: 'garden',
    cols: "id,name",
    user: store.state.auth.userData.id
  }).then(response => { plans.value = response.data })


  ReportService.getDevicesOptions({
    type:'container',
    user: store.state.auth.userData.id
  }).then(response =>{
   
  
    containers.value = response.data})
  
  return {
    devices,
    camps,
    tanks,
    fills,
    irrigations,
    owners,
    contracts,
    containers,
    plans,
    reFilterPlans,
    reFilterDevices
  }
}
